
import { IntegrationsTabs } from "@/components/integrations/IntegrationsTabs";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { DirectEnrichmentTester } from "@/components/integrations/DirectEnrichmentTester";

export default function Integrations() {
  const { data: isAdmin } = useIsAdmin();

  return (
    // AppLayout wrapper removed from here
    <div>
      <h1 className="text-3xl font-bold mb-6">Integrations</h1>
      <IntegrationsTabs isAdmin={isAdmin || false} />
      <DirectEnrichmentTester />
    </div>
    // AppLayout wrapper removed from here
  );
}

